/**
 * Fills in the 3 quiz-mirrored variables (location, fail-stack, spend bucket)
 * on outcome pages (Pages A/B/C) from URL query params set by the quiz app's
 * outcomePageUrl() (see ~/paximio-quiz/lib/outcome-pages.ts).
 *
 * Deliberately simple: plain JS, no framework, no server-side Liquid logic.
 * Every placeholder has sensible default text already in the HTML, so the
 * page reads fine even with no query params (direct visits, shared links).
 */
(function () {
  // Keep in sync with TRIED_LABELS / location option values in
  // ~/paximio-quiz/lib/quiz-data.ts (v5, 2026-07-16) — these are two
  // independent copies of the same mapping (Vercel app + this Shopify theme),
  // there's no shared package between them.
  var TRIED_LABELS = {
    "preshave-oil": "pre-shave oil or balm",
    aftershave: "aftershave or soothing products",
    "other-razor": "a different, more expensive razor",
    dermatologist: "a dermatologist",
    nothing: "nothing yet",
  };

  var SPEND_LABELS = {
    lt50: "under €50",
    "50-150": "€50–150",
    gt150: "over €150",
  };

  var LOCATION_LABELS = {
    neck: "neck",
    "jawline-cheeks": "jawline",
    everywhere: "face",
  };

  function joinTried(codes) {
    var labels = codes
      .map(function (c) {
        return TRIED_LABELS[c];
      })
      .filter(Boolean);
    if (labels.length === 0) return null;
    if (labels.length === 1) return labels[0];
    return labels.slice(0, -1).join(", ") + " and " + labels[labels.length - 1];
  }

  function fillVar(name, value) {
    if (!value) return;
    var els = document.querySelectorAll('[data-quiz-var="' + name + '"]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = value;
    }
  }

  function showConditional(name, shouldShow) {
    var els = document.querySelectorAll('[data-quiz-if="' + name + '"]');
    for (var i = 0; i < els.length; i++) {
      els[i].style.display = shouldShow ? "" : "none";
    }
  }

  var params = new URLSearchParams(window.location.search);

  var loc = params.get("loc");
  if (loc && LOCATION_LABELS[loc]) fillVar("loc", LOCATION_LABELS[loc]);

  var triedParam = params.get("tried");
  var tried = triedParam ? triedParam.split(",") : [];
  var triedText = joinTried(tried);
  if (triedText) fillVar("tried", triedText);
  showConditional("tried", Boolean(triedText));

  var spend = params.get("spend");
  if (spend && SPEND_LABELS[spend]) fillVar("spend", SPEND_LABELS[spend]);
  showConditional("spend", Boolean(spend && SPEND_LABELS[spend]));
})();
